module.exports = {
  "$id": "authenticate-other",
  "type": "object",
  "title": "儿童、港澳台及外籍旅客实名认证",
  "properties": {
    "name": {
      "title": "姓名",
      "type": "string"
    },
    "certType": {
      "title": "证件类型"
    },
    "idCard": {
      "title": "证件号码",
      "type": "string",
      "customValidate": "certNo"
    },
    "mobile": {
      "title": "手机号码",
      "type": "string",
      "customValidate": "mobile"
    },
    "email": {
      "title": "邮箱",
      "type": "string",
      "format": "email"
    }
  },
  "required": [
    "name",
    "certType",
    "idCard",
    "mobile"
  ],
  "errorMessage": {
    "name": {
      "required": "姓名不能为空"
    },
    "certType": {
      "required": "证件类型不能为空"
    },
    "idCard": {
      "required": "证件号码不能为空"
    },
    "mobile": {
      "required": "手机号码不能为空"
    }
  }
}
